import React, { useRef } from "react";

function Modal(props) {
  // 모달창닫기
  const closeModal = () => {
    document.querySelector(".modalWrap").classList.remove("openModal");
  };

  // 링크복사
  const textInput = useRef();

  const copy = () => {
    const el = textInput.current;
    el.select();
    document.execCommand("copy");
  };

  // Twitter 공유
  function shareTwitter() {
    var sendText = "찰떡궁합 MBTI";
    var sendUrl = "http://www.naver.com";
    window.open(
      "https://twitter.com/intent/tweet?text=" + sendText + "&url=" + sendUrl
    );
  }
  // Facebook 공유
  function shareFacebook() {
    var sendUrl = "http://www.naver.com";
    window.open("http://www.facebook.com/sharer/sharer.php?u=" + sendUrl);
  }

  return (
    <div className="modalWrap">
      <div className="dim"></div>
      <div className="shareModal">
        <strong className="tit">공유하기</strong>
        <div className="contents">
          <ul>
            <li>
              <button type="button" className="btnKakao">
                카카오톡
              </button>
            </li>
            <li>
              <button
                type="button"
                className="btnFacebook"
                onClick={shareFacebook}
              >
                페이스북
              </button>
            </li>
            <li>
              <button
                type="button"
                className="btnTwiter"
                onClick={shareTwitter}
              >
                트위터
              </button>
            </li>
          </ul>
          <div className="inputBox">
            <input
              type="text"
              defaultValue={props.infoLink}
              ref={textInput}
              readOnly
            />
            <button type="button" onClick={copy}>
              COPY
            </button>
          </div>
        </div>
        <button type="button" className="btnClose" onClick={closeModal}>
          닫기
        </button>
      </div>
    </div>
  );
}

export default Modal;
